import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle,
    Button, Table, Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import apiResponse from '../../../../services/apiResponse'
import CustomSelect from '../../../../helpers/ui/CustomSelect';

import DetailBloc from './Blocs/DetailBloc'
import moment from 'moment';

class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {
          document: null,
          isApprove: null,
          optionStatusApproval : [
              { label: "Disetujui", value: 1 },
              { label: "Ditolak", value: -1 }
          ],
        }
    }

    handleIsApproveSelect = (val) => {
        let selected = val.value;
        if (selected == 2) {
            this.setState({
                isApprove: 0
            })
        } else {
            this.setState({
                isApprove: 1
            })
        }
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
    };

    submitData = async () => {
        await this.detailBloc.fetchApprove(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values,
                uuid: this.state.detail?.employee_wfh_uuid
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
          this.detailBloc.approveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response,
                            document: response.document_letter
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }

    componentWillUnmount(){
      this.detailBloc.detailChannel?.unsubscribe()
      this.detailBloc.approveChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Approve Pengajuan WFH</CardTitle>
                                    {/* <CardSubtitle className="mb-3">
                                        Informasi Detail Pengajuan WFH
                                    </CardSubtitle> */}
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nomor Surat Keterangan WFH
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_wfh_letter_number !== "" ? this.state.detail.employee_wfh_letter_number : '-'}</>
                                                    : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                NIP
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_wfh_employee_nip !== "" ? this.state.detail.employee_wfh_employee_nip : '-'}</>
                                                    : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nama
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_wfh_employee_name !== "" ? this.state.detail.employee_wfh_employee_name : '-'}</>
                                                    : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">File Surat Keterangan WFH</Label>
                                            <Col md="6">
                                                {
                                                    this.state.detail ?
                                                        <>
                                                            {this.state.document !== null ?  
                                                                <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.document?.documents_path}>
                                                                    Download <i className="fa fa-download ms-1"></i>
                                                                </a>
                                                            : '-'}
                                                        </>
                                                    :
                                                        <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Tanggal WFH
                                            </label>
                                            <Col md="4">
                                                <Table className="table-bordered table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>No</th>
                                                            <th>Tanggal</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.detail?.details.length > 0 ? 

                                                                this.state.detail?.details.map((data, index) => {
                                                                    return (
                                                                        <tr>
                                                                            <td>{index+=1}</td>
                                                                            <td>{this.dateParse(data.employee_wfh_detail_date)}</td>
                                                                        </tr>
                                                                    );
                                                                })

                                                            : 
                                                            <tr>
                                                                <td colSpan="2" className="text-center">Tidak Ada Data</td>
                                                            </tr>
                                                        }
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Status Approval <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <CustomSelect 
                                                    name="status_approval"
                                                    errorMessage="Pilih Status Approval"
                                                    options={this.state.optionStatusApproval} 
                                                    placeholder="Pilih Status Approval"
                                                    validate={{ required: { value: true } }}
                                                    onChange={this.handleIsApproveSelect}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="status_approval_description"
                                                className="col-md-3 col-form-label"
                                            >
                                            Keterangan Approval <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="status_approval_description"
                                                    placeholder="Keterangan Approval..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Keterangan Approval"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="status_approval_description"
                                                />
                                            </Col>
                                        </Row>

                                        <hr />
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/pengajuan_wfh.html?'/>
                : null }
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);